import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatMenuModule } from "@angular/material/menu";
import { MatSliderModule } from "@angular/material/slider";

// Has to be in the same module as the HttpClient to work
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { MatListModule } from "@angular/material/list";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatRadioModule } from "@angular/material/radio";

const modules = [
	CommonModule,
	FormsModule,
	RouterModule,
	MatSliderModule,
	MatListModule,
	MatMenuModule,
	NgProgressHttpModule,
	MatFormFieldModule,
	MatInputModule,
	MatDatepickerModule,
	MatNativeDateModule,
	MatIconModule,
	MatProgressBarModule,
	MatRadioModule
];

@NgModule({
	imports: [...modules, NgProgressModule.withConfig({ spinner: false })],
	exports: [...modules, NgProgressModule]
})
export class AngularModule {}
